import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormDrawer from "components/__new/common/form-drawer";
import Maybe from "components/__new/common/Maybe";
import * as payrollSetupAction from "store/entities/payroll/payrollSetup/action";
import { PayStructureFormStep1 } from "./PayStructureFormStep1";
import { PayStructureFormStep2 } from "./PayStructureFormStep2";
import { generateUniqueId } from "utils/generateUniqueId";


const PayStructureForm = (props) => {
    const { isOpen, setIsOpen, payStructure, getPayStructures } = props;
    const dispatch = useDispatch();
    const { createPayStructureLoading, payStructureFormAction, editPayStructureLoading } = useSelector(state => state.entities.payrollSetup);
    const formAction = Object.keys(payStructure).length === 0 ? "create" : "edit";
    
    const formDefault = {
        name: "",
        country_code: "",
        salary_breakdown: [
            {
                salary_component: "BASIC",
                percentage: "",
                is_default: true,
                id: 1,
            },
            {
                salary_component: "HOUSING",
                percentage: "",
                is_default: true,
                id: 2,
            },
            {
                salary_component: "TRANSPORT",
                percentage: "",
                is_default: true,
                id: 3,
            },
        ],
        deductions: {
            pension_deduction: {
                is_enabled: false,
                pension_scheme: "",
            },
            nhf: false,
            nsitf: false,
            itf: false,
            custom_deductions: []
        }
    }
    
    const [form, setForm] = useState(formDefault);
    const [step, setStep] = useState(1);
   
    const handleTogglePayStructureModal = () => {
        setIsOpen(!isOpen);
    }
    
    const handleSubmitForm = async (evt) => {
        evt.preventDefault();
        const formattedData = {
            ...form,
            salary_breakdown: form.salary_breakdown.map(({ salary_component, percentage, is_default }) => ({ 
                salary_component, 
                percentage: +percentage, 
                is_default ,
            })),
            deductions: {
                ...form.deductions,
                custom_deductions: form.deductions.custom_deductions.map(({ name, description, source, type, value, is_shown_on_payslip, is_remitted_to_government }) => ({
                    name, 
                    description, 
                    source, 
                    type, 
                    value: +value, 
                    is_shown_on_payslip, 
                    is_remitted_to_government,
                })),
            }
        }
        
        if (formAction === "edit") {
            dispatch(payrollSetupAction.updatePayStructure(formattedData));
        } else {
            dispatch(payrollSetupAction.createPayStructure(formattedData));
        }
    }
    
    useEffect(() => {
        if (isOpen === true){
            let data = {...formDefault};
            if (formAction === "edit"){
                data = {
                    ...payStructure,
                    salary_breakdown: payStructure?.salary_breakdown?.map(({ salary_component, percentage, is_default }) => ({
                        salary_component,
                        percentage,
                        is_default,
                        id: generateUniqueId(),
                    })),
                    deductions: {
                        ...payStructure?.deductions,
                        custom_deductions: payStructure?.deductions?.custom_deductions.map(({ name, description, source, type, value, is_shown_on_payslip, is_remitted_to_government }) => ({
                            name, 
                            description, 
                            source, 
                            type, 
                            value: +value, 
                            is_shown_on_payslip, 
                            is_remitted_to_government,
                            id: generateUniqueId(),
                        })),
                    }
                };
                setForm(data);
                setStep(1);
            }
            else{
                setForm(formDefault);
            }
        }
        // eslint-disable-next-line
    }, [isOpen]);
    
    useEffect(() => {
        if (payStructureFormAction?.id !== "" && typeof payStructureFormAction?.id === "string"){
            // dispatch(payrollSetupAction.reset());
            setForm(formDefault);
            setIsOpen(false);
            getPayStructures();
            setStep(1);
        }
        // eslint-disable-next-line
    }, [payStructureFormAction])
    
    return (
        <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form onSubmit={handleSubmitForm}>
                <Maybe condition={step === 1}>
                    <PayStructureFormStep1
                        formAction={formAction} 
                        form={form} 
                        setForm={setForm} 
                        handleTogglePayStructureModal={handleTogglePayStructureModal} 
                        setIsOpen={setIsOpen} 
                        step={step} 
                        setStep={setStep}
                    />
                </Maybe>
                <Maybe condition={step === 2}>
                    <PayStructureFormStep2
                        formAction={formAction} 
                        form={form} 
                        setForm={setForm} 
                        handleTogglePayStructureModal={handleTogglePayStructureModal} 
                        setIsOpen={setIsOpen} 
                        step={step} 
                        setStep={setStep}
                        loading={createPayStructureLoading}
                        editLoading={editPayStructureLoading}
                    />
                </Maybe>
            </form>
        </FormDrawer>
    )
}


export default PayStructureForm;